import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  he: {
    translation: {
      //GENERAL
      "Modern Tarot": "מודרן טארוט",
      Reversed: "מהופך",
      Past: "העבר",
      Present: "ההווה",
      Future: "העתיד",
      Reshuffle: "פריסה חדשה",
      Answer: "תשובה",
      "Supporting / Blocking": "תומך או חוסם",
      "Your Daily Card": "הקלף היומי שלך",
      "Shuffling your cards...": "פורס את הקלפים...",
      "What I Think": "מה אני חושב\\ת",
      "How I Feel": "מה אני מרגיש\\ה",
      "What to Do": "מה אני עושה?",
      Loading: "טוען",
      Close: "סגירה",
      "Copy Spread": "העתקת קישור פריסה לשיתוף",
      "Your spread copied succesfully!": "הקישור לפריסה הועתק בהצלחה!",
      "Click on cards to read more":
        "לחצו על הקלפים על מנת ללמוד עוד על הפריסה",
      "Your question (optional)": "השאלה שלך (אופציונלי)",
      ModalMarketing:
        'אין תחליף לטארוט פיזי אמיתי. <a class="marketingLink underline font-bold" target="_blank" href="https://moderntarot.co.il/shop/">הזמינו אחד באתר שלנו עוד היום!</a>',
      //SPREADS
      "Daily Card": "הקלף היומי",
      "Past, Present, Future": "עבר, הווה, עתיד",
      "Think, Feel, Do": "מחשבה, הרגשה, מעשה",
      "S.O.S": "פריסת עזרה ראשונה S.O.S",
      //MAJOR ARCANA
      "The Fool": "השוטה",
      "The Magician": "הקוסם",
      "The High Priestess": "הכהנת",
      "The Empress": "הקיסרית",
      "The Emperor": "הקיסר",
      "The Hierophant": "הכהן הגדול",
      "The Lovers": "הנאהבים",
      "The Chariot": "המרכבה",
      Strength: "כח",
      "The Hermit": "הנזיר",
      "The Wheel of Fortune": "גלגל המזל",
      "The Tower": "המגדל",
      Justice: "צדק",
      "The Hanged Man": "התלוי",
      Death: "<span class='line-through'>מוות</span> לידה מחדש",
      Temperance: "מזג",
      "The Devil": "השטן",
      "The Star": "הכוכב",
      "The Moon": "הירח",
      "The Sun": "השמש",
      Judgement: "יום הדין",
      "The World": "העולם",
      //WANDS
      "Ace of Wands": "אס מטות",
      "Two of Wands": "שני מטות",
      "Three of Wands": "שלושה מטות",
      "Four of Wands": "ארבעה מטות",
      "Five of Wands": "חמישה מטות",
      "Six of Wands": "שישה מטות",
      "Seven of Wands": "שבעה מטות",
      "Eight of Wands": "שמונה מטות",
      "Nine of Wands": "תשעה מטות",
      "Ten of Wands": "עשרה מטות",
      "Page of Wands": "נסיך המטות",
      "Knight of Wands": "אביר המטות",
      "Queen of Wands": "מלכת המטות",
      "King of Wands": "מלך המטות",
      //CUPS
      "Ace of Cups": "אס גביעים",
      "Two of Cups": "שני גביעים",
      "Three of Cups": "שלושה גביעים",
      "Four of Cups": "ארבעה גביעים",
      "Five of Cups": "חמישה גביעים",
      "Six of Cups": "שישה גביעים",
      "Seven of Cups": "שבעה גביעים",
      "Eight of Cups": "שמונה גביעים",
      "Nine of Cups": "תשעה גביעים",
      "Ten of Cups": "עשרה גביעים",
      "Page of Cups": "נסיך הגביעים",
      "Knight of Cups": "אביר הגביעים",
      "Queen of Cups": "מלכת הגביעים",
      "King of Cups": "מלך הגביעים",
      //PENTACLES
      "Ace of Pentacles": "אס מטבעות",
      "Two of Pentacles": "שני מטבעות",
      "Three of Pentacles": "שלושה מטבעות",
      "Four of Pentacles": "ארבעה מטבעות",
      "Five of Pentacles": "חמישה מטבעות",
      "Six of Pentacles": "שישה מטבעות",
      "Seven of Pentacles": "שבעה מטבעות",
      "Eight of Pentacles": "שמונה מטבעות",
      "Nine of Pentacles": "תשעה מטבעות",
      "Ten of Pentacles": "עשרה מטבעות",
      "Page of Pentacles": "נסיך המטבעות",
      "Knight of Pentacles": "אביר המטבעות",
      "Queen of Pentacles": "מלכת המטבעות",
      "King of Pentacles": "מלך המטבעות",
      //SWORDS
      "Ace of Swords": "אס חרבות",
      "Two of Swords": "שתי חרבות",
      "Three of Swords": "שלוש חרבות",
      "Four of Swords": "ארבע חרבות",
      "Five of Swords": "חמש חרבות",
      "Six of Swords": "שש חרבות",
      "Seven of Swords": "שבע חרבות",
      "Eight of Swords": "שמונה חרבות",
      "Nine of Swords": "תשע חרבות",
      "Ten of Swords": "עשר חרבות",
      "Page of Swords": "נסיך החרבות",
      "Knight of Swords": "אביר החרבות",
      "Queen of Swords": "מלכת החרבות",
      "King of Swords": "מלך החרבות",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "he", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
